import axios from 'axios'
import mainUrl from './mainUrl'

axios.defaults.baseURL = mainUrl
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Accept'] = '*/*'
axios.defaults.headers.common['Content-Type'] = 'application/json'
export default axios
